import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/ProjectWorkflowFoundation"
    : "SLN/SolarentOperator/ProjectWorkflowFoundation";

const unwrapPayload = (res) => res?.data ?? res ?? null;

const ProjectProcurementActivationApi = {
  getProcurementRequestItems: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetProcurementRequestItems?requestId=${encodeURIComponent(requestId)}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  getProcurementTriggerMilestones: async (source, requestId) => {
    const q =
      requestId != null && requestId !== ""
        ? `?requestId=${encodeURIComponent(requestId)}`
        : "";
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetProcurementTriggerMilestones${q}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  getProcurementActivations: async (source, { requestId, projectExecutionPlanId } = {}) => {
    const params = new URLSearchParams();
    if (requestId) params.set("requestId", requestId);
    if (projectExecutionPlanId) params.set("projectExecutionPlanId", projectExecutionPlanId);
    const q = params.toString() ? `?${params.toString()}` : "";
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetProcurementActivations${q}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  createProcurementActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CreateProcurementActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  requestProcurementQuotation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/RequestProcurementQuotation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  selectProcurementSupplier: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/SelectProcurementSupplier`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  suspendProcurementActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/SuspendProcurementActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  cancelProcurementActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CancelProcurementActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  completeProcurementActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CompleteProcurementActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },
};

export default ProjectProcurementActivationApi;
